var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    staticStyle: {
      "overflow-x": "auto"
    },
    attrs: {
      "max-width": _vm.selectedItemType === 1 ? 1200 : _vm.selectedItemType === 3 ? 700 : 500,
      "persistent": _vm.$store.state.loading
    },
    model: {
      value: _vm.dialogVisible,
      callback: function ($$v) {
        _vm.dialogVisible = $$v;
      },
      expression: "dialogVisible"
    }
  }, [_c('v-card', [_c('v-card', {
    staticStyle: {
      "position": "sticky",
      "top": "0",
      "z-index": "1000"
    },
    attrs: {
      "loading": _vm.$store.state.loading,
      "tile": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "v-sheet theme--dark v-toolbar secondary"
  }, [_vm.selectedItemType ? _c('v-btn', {
    attrs: {
      "dark": "",
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.resetSelectedItemType();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-arrow-left")])], 1) : _vm._e(), _c('v-toolbar-title', [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "dark": "",
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.closeAddItemModal();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1)], 1), _c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-container', [!_vm.selectedItemType ? _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h3', [_vm._v("Please select the item type below you want to add.")])]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('span', [_c('v-tooltip', {
    attrs: {
      "disabled": _vm.canSellTaxis,
      "color": "black",
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('span', _vm._g(_vm._b({}, 'span', attrs, false), on), [_c('v-btn', {
          staticClass: "mr-2",
          staticStyle: {
            "color": "#fec33a"
          },
          attrs: {
            "disabled": !_vm.canSellTaxis,
            "color": "#2b2b2b"
          },
          on: {
            "click": _vm.handleTaxiClick
          }
        }, [_vm._v("Taxi ")])], 1)];
      }
    }], null, false, 141417157)
  }, [_c('span', [_vm._v("Tenant " + _vm._s(_vm.tenantName) + " is not allowed to sell taxis.")])])], 1), _c('span', [_c('v-tooltip', {
    attrs: {
      "disabled": _vm.canUseGiftcard,
      "color": "black",
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref2) {
        var on = _ref2.on,
          attrs = _ref2.attrs;
        return [_c('span', _vm._g(_vm._b({}, 'span', attrs, false), on), [_c('v-btn', {
          staticClass: "mr-2 white--text",
          staticStyle: {
            "background-color": "rgb(112, 163, 127)",
            "border-color": "rgb(112, 163, 127)"
          },
          attrs: {
            "disabled": !_vm.canUseGiftcard
          },
          on: {
            "click": function ($event) {
              return _vm.handleAddItemTypeClick(2);
            }
          }
        }, [_vm._v("Gift Card ")])], 1)];
      }
    }], null, false, 1655013590)
  }, [_c('span', [_vm._v("Tenant " + _vm._s(_vm.tenantName) + " is not allowed to sell gift cards.")])])], 1), _c('v-btn', {
    staticClass: "mr-2 white--text",
    staticStyle: {
      "background-color": "rgb(93, 145, 232)",
      "border-color": "rgb(93, 145, 232)"
    },
    on: {
      "click": function ($event) {
        return _vm.handleAddItemTypeClick(3);
      }
    }
  }, [_vm._v("Article ")]), _c('v-btn', {
    staticClass: "mr-2 white--text",
    staticStyle: {
      "background-color": "rgb(134, 146, 197)",
      "border-color": "rgb(134, 146, 197)"
    },
    on: {
      "click": function ($event) {
        return _vm.handleAddItemTypeClick(4);
      }
    }
  }, [_vm._v("Distribution ")])], 1)], 1) : _vm._e(), _c('v-row', [_vm.keepTaxiWidgetAlive ? _c('v-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.selectedItemType === 1,
      expression: "selectedItemType === 1"
    }],
    attrs: {
      "cols": "12"
    }
  }, [_vm._t("taxi")], 2) : _vm._e(), _vm.selectedItemType === 2 ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._t("gift-card")], 2) : _vm._e(), _vm.selectedItemType === 3 ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._t("article")], 2) : _vm._e(), _vm.selectedItemType === 4 ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._t("distribution")], 2) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }